import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_PROVIDERS_SUCCESS:
      return Object.assign({}, state, {
        providers: action.providers,
      });
    case constants.GET_PROVIDER_SUCCESS:
      return Object.assign({}, state, {
        provider: action.provider,
        isRefreshRequired: false,
      });
    case constants.POST_PROVIDER_SUCCESS:
      return Object.assign({}, state, {
        provider: action.provider,
        newId: action.provider.data.id,
      });
    case constants.PATCH_PROVIDER_SUCCESS:
      // TODO: Fix or investigate - API returning true/false instead of the patched object.
      return Object.assign({}, state, {
        // provider: action.provider,
        isRefreshRequired: true,
      });
    case constants.POST_CLONE_PROVIDER_SUCCESS:
        return Object.assign({}, state, {
        provider: action.provider,
        isRefreshRequired: true,
    });
    case constants.UPLOAD_POI_MEDIA_SUCCESS:
      return Object.assign({}, state, {
        poiUploadUrl: action.poiUpload.Location,
      });
    case constants.PUT_POIS_SUCCESS:
      return Object.assign({}, state, {
        isRefreshRequired: true,
      });
    case constants.LINKED_USERS_SUCCESS:
      return Object.assign({}, state, {
        LinkedUsers: action.data,
      });
    case constants.DELETE_LINKED_USERS_SUCCESS:
      return Object.assign({}, state, {
        linkedUserDeleteSuccess: action.data,
      });
    case constants.GET_PROVIDERS_ERROR:
    case constants.GET_PROVIDER_ERROR:
    case constants.POST_PROVIDER_ERROR:
    case constants.PATCH_PROVIDER_ERROR:
    case constants.PUT_POIS_ERROR:
    case constants.UPLOAD_POI_MEDIA_ERROR:
    case constants.LINKED_USERS_ERROR:
    case constants.DELETE_LINKED_USERS_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
